'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ColorPickerPanel = require('./ColorPickerPanel');

var _ColorPickerPanel2 = _interopRequireDefault(_ColorPickerPanel);

var _utils = require('../utils');

var _rcEditorUtils = require('rc-editor-utils');

var _rcEditorUtils2 = _interopRequireDefault(_rcEditorUtils);

var _ColorPickerBtn = require('./ColorPickerBtn');

var _ColorPickerBtn2 = _interopRequireDefault(_ColorPickerBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getCurrentInlineStyle = _rcEditorUtils2["default"].getCurrentInlineStyle,
    getCurrentEntity = _rcEditorUtils2["default"].getCurrentEntity;

var defaultFontColor = '000';
var PREFIX = 'FONTCOLOR_';
var fontColor = {
    constructor: function constructor(config) {
        var callbacks = {
            getEditorState: _utils.noop,
            setEditorState: _utils.noop
        };
        var applyStyle = (0, _utils.getApplyFontStyleFunc)(PREFIX, callbacks);
        function changeSelect(_ref) {
            var color = _ref.color;

            var colorString = color.substring(1);
            applyStyle('' + PREFIX + colorString, true);
        }
        function customStyleFn(styleSet) {
            return styleSet.map(function (style) {
                if (style.indexOf(PREFIX) !== -1) {
                    var color = '#' + style.substring(PREFIX.length);
                    return {
                        color: color
                    };
                }
                return {};
            }).reduce(function (prev, curr) {
                return Object.assign(prev, curr);
            });
        }
        return {
            name: 'fontColor',
            callbacks: callbacks,
            customStyleFn: customStyleFn,
            component: function component(props) {
                var editorState = callbacks.getEditorState();
                var currentStyle = getCurrentInlineStyle(editorState);
                var currentFontColor = currentStyle && currentStyle.find(function (item) {
                    return item.indexOf('' + PREFIX) !== -1;
                });
                var fontColor = currentFontColor ? currentFontColor.substring(PREFIX.length) : defaultFontColor;
                return _react2["default"].createElement(
                    _ColorPickerPanel2["default"],
                    { prefixCls: config.prefixCls + '-editor', defaultColor: '#' + defaultFontColor, animation: 'slide-up', color: '#' + fontColor, onChange: changeSelect },
                    _react2["default"].createElement(_ColorPickerBtn2["default"], { style: { backgroundColor: '#' + fontColor } })
                );
            }
        };
    }
};
exports["default"] = fontColor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-basic-style@0.3.6@rc-editor-plugin-basic-style/lib/FontColor/index.js
// module id = 210
// module chunks = 0 1 2